<iframe #inmessageIframe width="100%" height="100%" style="border: 0; margin: 0; padding: 0"> </iframe>

<button
  *ngIf="canCustomize && !customization"
  [ngClass]="chatPosition"
  mat-button
  color="primary"
  class="customize-in-message"
  (click)="enableCustomization()">
  <mat-icon>settings</mat-icon>&nbsp;
  <span>{{ 'accounts/edition/test-link/inmessage-chat/customize-button' | translate }}</span>
</button>
